import { USPV011 } from "pages/USPV011";
import ClinicSettingPage from "pages/clinic_settings";
import GraphComponent from "pages/graph";
import USPV007 from "pages/help-page";
import NotificationPage from "pages/notification";
import PatientEditPage from "pages/patient_edit";
import PatientsPage from "pages/patients";
import { ROUTE } from "./route";
import Document from "pages/clinic/components/document/Document";

const clinicRoutes = [
  {
    path: ROUTE.CLINIC.SETTING,
    component: ClinicSettingPage,
  },
  {
    path: ROUTE.CLINIC.PATIENT,
    component: PatientsPage,
  },
  {
    path: ROUTE.CLINIC.PATIENT_EDIT,
    component: PatientEditPage,
  },
  {
    path: ROUTE.CLINIC.GRAPH,
    component: GraphComponent,
  },
  {
    path: ROUTE.CLINIC.HELP_PAGE,
    component: USPV007,
  },
  {
    path: ROUTE.CLINIC.NOTIFICATION,
    component: NotificationPage,
  },
  {
    path: ROUTE.CLINIC.CODE,
    component: USPV011,
  },
  {
    path: ROUTE.CLINIC.FIRST_PAGE,
    component: Document,
  },
];

export default clinicRoutes;
